import { render } from "./TorneoDetail.vue?vue&type=template&id=cba2f7ee&scoped=true"
import script from "./TorneoDetail.vue?vue&type=script&lang=js"
export * from "./TorneoDetail.vue?vue&type=script&lang=js"

import "./TorneoDetail.vue?vue&type=style&index=0&id=cba2f7ee&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba2f7ee"]])

export default __exports__